module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-blank-a8ebda26.svg";